export default function TdsFormulaCard({ title, children }) {
  return (
    <div className="tds-formula">
      {title ? <div className="tds-formula-title">{title}</div> : null}
      <div className="tds-formula-expr">{children}</div>
    </div>
  );
}
